import { RootState } from '@core/store/rootReducer';
import { createSelector } from '@reduxjs/toolkit';
import { MapFilters, MapState } from './map.reducer';

const mapState = (state: RootState) => state.map;

export const selectMapTogglersState = createSelector([mapState], (state: MapState) => state.togglers);

export const selectMapFilters = createSelector([mapState], (state: MapState): MapFilters => {
  return state.filters;
});

export const selectDisplayCorrelateSites = createSelector([mapState], (state: MapState) => {
  return state.correlateSitesMode;
});
export const selectEditedSiteLatLng = createSelector([mapState], (state: MapState): boolean => state?.editedSiteLatLng);
